import styled from 'styled-components';
import { IconsSizes, Media } from 'enums';

export const Icon = styled.img`
  width: ${IconsSizes.M};
  height: ${IconsSizes.M};

  @media ${Media.notebook} {
    width: ${IconsSizes.L};
    height: ${IconsSizes.L};
  }
`;
